import { Dispatch } from 'redux';
import {
  POLICY_SEARCH,
  POLICY_SEARCH_SUCCESS,
  POLICY_SEARCH_FAILED,
  PolicySearchData,
  POLICY_SORT,
  PolicySearchGridSort,
  PLAN_NAME,
  POLICY_SEARCH_RESET
} from './types';
import { ApiClient } from '../api.client';
import { ReduxStore } from '../payload-types';
import { LINKS, PLAN_NAME_QUERY } from '@trip-ux/constants';
import { first, get, map, reduce, toUpper } from 'lodash';
import { time } from 'uniqid';

export const sortPolicies = (payload: PolicySearchGridSort) => (dispatch: Dispatch) => {
  dispatch({ type: POLICY_SORT, payload });
};

export const getPolicies =
  (payload: PolicySearchData) =>
  (
    dispatch: Dispatch,
    getState: () => ReduxStore,
    apiClient: ApiClient
  ): Promise<void | { type: string; payload: unknown }> => {
    dispatch({ type: POLICY_SEARCH, payload });
    return apiClient(dispatch, getState)
      .get(LINKS.POLICY, { params: { ...payload, ts: time() } })
      .then(data => {
        type RecordType = { paxes?: Array<{ plan?: { code?: string } }> };
        const records: RecordType[] = get(data, 'records', []);
        const planCodes = map(records, val => get(first(val.paxes), 'plan.code'));
        getPlanNames(planCodes)(dispatch, getState, apiClient);
        dispatch({ type: POLICY_SEARCH_SUCCESS, payload: data });
        sortPolicies({ field: 'purchaseDate', order: 'desc' })(dispatch);
      })
      .catch(e => dispatch({ type: POLICY_SEARCH_FAILED, payload: e }));
  };

export const getPlanNames =
  (payload: string[]) =>
  (
    dispatch: Dispatch,
    getState: () => ReduxStore,
    apiClient: ApiClient
  ): Promise<void | { type: string; payload: unknown }> => {
    return apiClient(dispatch, getState)
      .post(LINKS.GRAPHQL, {
        query: PLAN_NAME_QUERY,
        variables: { lang: toUpper(getState().config.locale), where: { code: { $in: payload } } }
      })
      .then(({ data }) => {
        const planNames = reduce(data.plans, (res, val) => ({ [val.code]: val.content.name, ...res }), {});
        dispatch({ type: PLAN_NAME, payload: planNames });
      })
      .catch(e => dispatch({ type: PLAN_NAME, payload: e }));
  };

export const policySearchReset =
  () =>
  (dispatch: Dispatch): void => {
    dispatch({
      type: POLICY_SEARCH_RESET
    });
  };
